<div class="guardar" *ngIf="nickName !== 'DoctorClick'">
  <h5 (click)="open(content)">
    <span class="mas">
      <img src="../assets/plus.png" alt="agregar" />
    </span>
    Especialidades:
  </h5>
</div>
<div class="abajo">
  <div
    class="especialidades mb-1"
    *ngFor="let especialidad of especialidadArray"
  >
    <h5 class="especialidad row">
      <span class="col-8">{{ especialidad.name }}</span>
      <span class="cancelar col-2" (click)="quitarEspecialidad(especialidad.id)"
        ><img src="../assets/cancel.png" alt="eliminar"
      /></span>
    </h5>
  </div>
</div>

<!-- modal -->
<ng-template #content let-modal>
  <div class="modal-body">
    <div class="cerrar">
      <a
        class="cerrar-boton"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </a>
    </div>
    <h4>Seleccione una especialidad</h4>
    <div class="continuar">
      <div class="form-row">
        <div class="form-group row">
          <select
            name=""
            id=""
            class="form-select form-control col-12 col-md-7"
            [(ngModel)]="seleccionado"
          >
            <option value="0">Seleccione...</option>
            <option
              [value]="especialidad.id"
              *ngFor="let especialidad of especialidades"
            >
              {{ especialidad.name }}
            </option>
          </select>
          <button
            type="button"
            class="btn boton boton2 col-12 col-md-4"
            (click)="agregarEspecialidad()"
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
    <div class="mt-3" *ngIf="especialidadSeleccionada !== ''">
      <h4 class="text-center">
        La especialidad "{{ especialidadSeleccionada }}" fue agregada.
      </h4>
      <h4 class="text-center">Puedes continuar agregando especialidades</h4>
      <h4 class="text-center">Para salir puedes dar click a la x</h4>
    </div>
  </div>
</ng-template>
